import { Box, Skeleton, Typography } from '@mui/material';
import SensitiveInfoTypography from '~/components/SensitiveInfoTypography';
import { StructureSet } from '~/domain/patient/structureset';
import { cutUID } from '~/utils/string';

type InputDataDisplayProps = {
    structureSet?: StructureSet;
    isLoading?: boolean;
};

const SkeletonLoader = () => (
    <Box>
        <Skeleton variant="text" width="20%" height={24} />
        <Skeleton variant="text" width="60%" height={18} />
        <Skeleton variant="text" width="30%" height={18} />
    </Box>
);

export default function StructureSetDataPreview({
    structureSet,
    isLoading,
}: InputDataDisplayProps) {
    return isLoading ? (
        <SkeletonLoader />
    ) : structureSet ? (
        <Box width="100%" position="relative">
            <Box display="flex" gap={0.5} alignItems="end">
                <Typography>RTSTRUCT</Typography>
                <Typography color="primary" fontSize={12} lineHeight={1.8}>
                    ({structureSet?.roiArray.length})
                </Typography>
            </Box>
            <Typography
                fontSize={12}
                sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
            >
                {structureSet.structureSetLabel}
            </Typography>
            <SensitiveInfoTypography>
                <Typography fontSize={12} variant="body2">
                    {cutUID(structureSet?.dicomUid, 4, 6)}
                </Typography>
            </SensitiveInfoTypography>
        </Box>
    ) : (
        <Typography variant="body2">No structure set selected</Typography>
    );
}
